import React, { useContext, useEffect, useState } from "react";
import Header2 from "../Coman/Header2";
import { FaCopy } from "react-icons/fa6";
import { RiTeamFill } from "react-icons/ri";

import "react-circular-progressbar/dist/styles.css";
import ProgressBar from "./ProgressBar";
import DashbordTable from "./DashbordTable";
import Timer from "../Coman/Timer";
import CreateNYOModal from "./CreateNYOModal";
import MultiTierYieldModal from "./MultiTierYieldModal";
import DailyNYOModal from "./DailyNYOModal";
import { ProjectContext } from "../../ProjectContext";

function Dashboard() {

  const {
    account,
    copyaddress, dbuser, formatAddress, usertnx,
    usertnxDate, Earnig, Team, dnetRate, Ubalance, Dbalance, getFormattedDate, AllReward,AllRewardNew, PLevelReward, PDailyReward, user72Date, Rank, dbuserx1, dbReward, DailyReward, TDailyRew 
  } = useContext(ProjectContext)
  const currentTimestampInSeconds = Math.floor(Date.now() / 1000);
  // Usage
  const formattedDateTime72 = getFormattedDate(user72Date);

  const formattedDateTime = getFormattedDate(usertnxDate);
  const formattedCDateTime = getFormattedDate(currentTimestampInSeconds);
  var balance = dnetRate * Dbalance
  const normalizedValue = dbuserx1 === 0 ? 0 : (dbReward / dbuserx1) * 100;
  const [showtab, setShowTab] = useState(0);
  return (
    <div>
      <div
        style={{
          backgroundImage: `url('../assets/images/img/background.gif')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          width: "100%",
        }}
      >
        <Header2 />{" "}
        <div className=" container mt-5">
          <div className="row justify-content-center">
            <div className="col-xl-12 my-3">
              <div className="new-card ">
                <div className="new-box">
                  <div className="row align-items-center justify-content-center">
                    <div className="col-lg-8 col-md-12 d-flex justify-content-center justify-content-lg-start">
                      <div>
                        <h3 className="">Welcome , NYO Protocol</h3>
                        <p className="mb-5">
                          Effortless DeFi Growth at Your Fingertips
                        </p>
                        <h6 className="'d-flex align-items-center c-pointer my-3">
                          <b>Account Address :{" "}</b>
                          <span className="ml-2">{formatAddress(account)} </span>
                          <span className="ml-1">
                            <FaCopy onClick={() => copyaddress(account)} />
                          </span>
                        </h6>
                        <h6 className="'d-flex align-items-center c-pointer ">
                          <b>Backers Address :</b>
                          <span className="ml-2">{formatAddress(dbuser?.ref_address)} </span>
                          <span className="ml-1">
                            <FaCopy onClick={() => copyaddress(dbuser?.ref_address)} />
                          </span>
                        </h6>
                        <div>
                          <button class="neu-button mr-3">
                            {Rank === "Master" ?
                              <span className="text-success fs-4">Achived &nbsp; <img src="https://fonts.gstatic.com/s/e/notoemoji/latest/1f60e/512.webp" alt="" width={40} height={40} srcset="" /></span>
                              :
                              <span className="d-flex justify-content-between">
                                <Timer targetDate={dbuser ? formattedDateTime72 : ""} />
                              </span>
                            }
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-4 my-3 col-md-12 d-flex justify-content-center">
                      <ProgressBar />
                    </div>
                  </div>
                </div>
                <div className="col-12 text-center">
                  <p className="blink_me text-danger mt-2 mb-0">{normalizedValue > 100 ? "Your next Recreate will be available shortly. Keep going!" : ""}</p>
                  < p className="my-0">My Balance</p>
                  <h3 className="fw-bold"> ${balance.toFixed(2)} ({Number(Dbalance).toFixed(2)} {process.env.REACT_APP_TOKEN_TICKER})</h3>
                </div>

                <div className="new-box-body">
                  <div className="d-flex justify-content-between  flex-lg-nowrap flex-wrap w-100">

                    <button className="styled-button my-2 mx-2 my-md-0 w-100">
                      <div className="inner-button">
                        <div className=" m-1 px-1">
                          {" "}
                          <RiTeamFill />
                        </div>
                      </div>
                      Engineers : {Team ? Team : "--"}
                    </button>
                    <button className="styled-button my-2 mx-2 my-md-0 w-100" onClick={() => copyaddress(`${process.env.REACT_APP_URL}login/${dbuser?.address}`)}>
                      <div className="inner-button">
                        <div className=" m-1 px-1">
                          {" "}
                          <RiTeamFill />
                        </div>
                      </div>
                      Backers Link
                    </button>
                    <button className="styled-button my-2 mx-2 my-lg-0 w-100">
                      <div className="inner-button">
                        <div className=" m-1 px-1">
                          {" "}
                          <RiTeamFill />
                        </div>
                      </div>
                      Earning : {Earnig ? "$" + Earnig : "--"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-12 my-3">
              <div className="new-card ">
                <div className="new-box-body">
                  <div className="d-flex justify-content-around flex-lg-nowrap flex-wrap w-100">
                    <CreateNYOModal />
                    <MultiTierYieldModal />
                    <DailyNYOModal />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-12 my-3">
              <div className="new-card ">
                <div className="new-box-body">
                  <div className="d-flex justify-content-around flex-lg-nowrap flex-wrap w-100">
                    <button className="styled-button my-2 mx-2 my-lg-0 w-100">
                      <div className="inner-button">
                        <div className=" m-1 px-1">
                          {" "}
                          <RiTeamFill />
                        </div>
                      </div>
                      Rank : {Rank}
                    </button>
                    <button className="styled-button my-2 mx-2 my-lg-0 w-100">
                      <div className="inner-button">
                        <div className=" m-1 px-1">
                          {" "}
                          <RiTeamFill />
                        </div>
                      </div>
                      Rank Reward : {AllReward?.extrareward ? "$" + Number(AllReward?.extrareward).toFixed(2) : "--"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12">
              <iframe
                src="https://www.dextools.io/widget-chart/en/arbitrum/pe-light/0xf5b167e826dc25077923c918f33d41b424193652?theme=dark&chartType=0&chartResolution=10&drawingToolbars=false&tvPlatformColor=000000&tvPaneColor=ffffff&headerColor=000000&chartInUsd=true"
                width="100%"
                height="500px"
                frameBorder="0"
                allowfullscreen
                title="DEXTools Chart"
              />
            </div>


            <div className="col-lg-4 col-md-6 my-3">
              <div className="new-card ">
                <div className="new-box">
                  <h4 className="my-3">Current NYO</h4>
                  <h3 className="">{usertnx ? "$" + Number(usertnx).toFixed(2) : "--"}</h3>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 my-3">
              <div className="new-card ">
                <div className="new-box">
                  <h4 className="my-3">Total NYO</h4>
                  <h3 className="">{dbuser ? "$" + Number(dbuser.stake).toFixed(2) : "--"}</h3>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 my-3">
              <div className="new-card ">
                <div className="new-box">
                  <div className="d-flex my-3 justify-content-between align-content-center">
                    <h4 className="">Daily Yield</h4>
                  </div>
                  <Timer targetDate={dbuser ? formattedDateTime : ""} />
                  <h3 className="">{DailyReward ? "$" + Number(DailyReward).toFixed(2) : "--"}</h3>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 my-3">
              <div className="new-card ">
                <div className="new-box">
                  <h4 className="my-3">Multitier Yield</h4>
                  <h3 className="">{AllReward?.levelreward ? "$" + Number(AllReward?.levelreward).toFixed(2) : "--"}</h3>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 my-3">
              <div className="new-card ">
                <div className="new-box">
                  <h4 className="my-3">Open Tier</h4>
                  <h3 className="">{dbuser ? dbuser?.directs > 6 ? "All Level Open" : Number(dbuser?.directs).toFixed(2) : "--"} </h3>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 my-3">
              <div className="new-card ">
                <div className="new-box">
                  <h4 className="my-3">Rest Multitier </h4>
                  <h3 className="">{PLevelReward ? "$" + Number(PLevelReward).toFixed(2) : "--"}</h3>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 my-3">
                <div className="new-card ">
                    <div className="new-box">
                        <h4 className="my-3">Rest Daily </h4>
                        <h3 className="">{PDailyReward ? "$" + Number(PDailyReward).toFixed(2) : "--"}</h3>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 my-3">
                <div className="new-card ">
                    <div className="new-box">
                        <h4 className="my-3">Claimed Daily </h4>
                        <h3 className="">${((AllReward?.rwithdrawal ? Number(AllReward.rwithdrawal) : 0) + (AllRewardNew?.rwithdrawal ? Number(AllRewardNew.rwithdrawal) : 0)).toFixed(2)}</h3>
                    </div>
                </div>
            </div>
            <div className="col-lg-4 col-md-6 my-3">
                <div className="new-card ">
                    <div className="new-box">
                        <h4 className="my-3">Claimed Multitier </h4>
                        <h3 className="">${((AllReward?.lwithdrawal ? Number(AllReward.lwithdrawal) : 0) + (AllRewardNew?.lwithdrawal ? Number(AllRewardNew.lwithdrawal) : 0)).toFixed(2)}</h3>
                    </div>
                </div>
            </div>
          </div>
          <DashbordTable />
        </div>
      </div>
      <div>{/* Button trigger modal */}</div>
    </div>
  );
}

export default Dashboard;